import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppMedia } from './';

interface SectionHeroProduct {
    __component?: string;
    data?: any;
}

export const SectionHeroProduct: FunctionalComponent<SectionHeroProduct> = ({ data }) => {

    const { Title, Subtitle, Media, CTA, Slug } = data;

    const OwnerCTA = { URL: `/owners/${Slug}`, Label: 'Operators Manual' }

    return (
        <section class="uk-light">
            <div class="uk-container uk-container-large">
                <div class="uk-background-muted-full uk-child-width-1-1 uk-child-width-1-2@s uk-grid-collapse uk-grid-match" uk-grid>
                    <div class="uk-height-min-medium uk-height-min-50@s">
                        <div class="uk-position-relative uk-background-primary-diag uk-flex uk-flex-column">
                            <div class="uk-padding-large uk-flex-1 uk-flex uk-flex-middle">
                                <div>
                                    <div class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</div>
                                    <h1 class="uk-heading-xlarge uk-margin-remove-top uk-margin-medium-bottom">{Title}</h1>
                                    <div class="uk-margin-top uk-flex@m">
                                        <AppLink data={CTA} className="uk-button uk-button-default" />
                                        <div class="uk-margin-medium-left uk-margin-top"></div>
                                        <AppLink data={OwnerCTA} className="uk-button uk-button-text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-height-min-medium uk-muted-striped uk-height-1-1">
                        {/* <model-viewer src="/assets/images/models/es-22/es-22.gltf" ar ar-modes="webxr scene-viewer quick-look" camera-controls tone-mapping="neutral" poster="poster.webp" shadow-intensity="1.22" exposure="0.82" shadow-softness="1">
                            <button class="uk-button-default uk-width-1-2" style={{ background: 'rgba(0,0,0,0.6)' }} slot="hotspot-1" data-position="0.3094375057007105m 0.07037628309283273m 0.3079991638660431m" data-normal="0m 0m 1m" data-visibility-attribute="visible">
                                <div class="HotspotAnnotation">Easy adjustment of bottom blade to cylinder</div>
                            </button><button class="uk-button-default uk-width-1-2" style={{ background: 'rgba(0,0,0,0.6)' }} slot="hotspot-2" data-position="0.023221806853261084m 0.4646142929942263m -0.11627465813860027m" data-normal="0.6819981124348515m 0.7313539325356087m 0m" data-visibility-attribute="visible">
                                <div class="HotspotAnnotation">Easy connect disconnect battery to electrical system</div>
                            </button><button class="uk-button-default uk-width-1-2" style={{background:'rgba(0,0,0,0.6)'}} slot="hotspot-3" data-position="-0.5372345292955159m 0.7903959164955229m 0.0007776989441654059m" data-normal="-0.6367282291709158m 0.7710882972635946m -2.3411596837143737e-8m" data-visibility-attribute="visible">
                                <div class="HotspotAnnotation">Easy screen control</div>
                            </button>
                            <div class="progress-bar hide" slot="progress-bar">
                                <div class="update-bar"></div>
                            </div>
                            <button slot="ar-button" id="ar-button">
                                View in your space
                            </button>
                        </model-viewer> */}

                        <AppMedia media={Media} eager size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 45vw" />
                    </div>
                </div>
            </div>
        </section>
    )
};
